import { InjectionToken, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

export interface SharedAccountContactItem {
  access_flags: number;
  principal_contact_id: number;
  user_id: number;
  user_first_name: string;
  user_last_name: string;
  user_email_address: string;
  user_phone: string;
  user_company_label: string;
}

export interface SharedContactsResponse {
  success: boolean;
  message: string | null;
  error: any;
  data: {
    contacts: SharedAccountContactItem[];
    total_contacts?: number;
  };
}

export interface SharedContactsService {
  getContacts(params?: Record<string, any>): Observable<{ contacts: SharedAccountContactItem[]; total: number }>;
  createContact(payload: Partial<SharedAccountContactItem>): Observable<SharedAccountContactItem>;
}

export const CONTACTS_PROVIDER_TOKEN = new InjectionToken<SharedContactsService>('CONTACTS_PROVIDER_TOKEN');


